/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Button, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';


const AdvCampaignTable = ({

    data,
    tableHeaderData,
    fileName,
    title,
}) => {
    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = data?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];

        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');

        // Write the file
        XLSX.writeFile(wb, `${fileName || 'Report'}.xlsx`);
    };

    return (
        <div >
            <div className="modal__header">
                <h4 className="text-modal  modal__title">{title || 'Report'}</h4>
                <div className="ExcelTable" id='dvTable'>
                    <Button
                        disabled={!data.length}
                        className="download-monthly-sub-order-report btn-primary btn btn-sm"
                        onClick={handleDownload}
                    >
                        Download
                    </Button>
                </div>
            </div>
            <div className="modal__body">
                <Row>
                    <ResizableDataTable
                        customClass="pt-0"
                        reactTableData={{ tableHeaderData }}
                        data={data}
                    />
                </Row>
            </div>
        </div>
    )
};

AdvCampaignTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    fileName: PropTypes.string,
    title: PropTypes.string,
};

AdvCampaignTable.defaultProps = {
    fileName: '',
    title: '',
};

export default AdvCampaignTable;
